/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import Modal from '../../UniformComponents/Modal'
import Select from '../form/Select'
import Input from '../form/Input'
import Checkbox from '../form/Checkbox'
import Panel from '../../UniformComponents/Panel'
import Button from '../../UniformComponents/Button'
import './creationWizard/creationWizard.scss'

@observer
class DefaultDashboardSetter extends Component {
    scopeOptions = [
        { label: 'Company', value: 3 },
        { label: 'Portfolio', value: 5 },
        { label: 'Event', value: 6 },
    ]

    constructor(props) {
        super(props)
        this.state = {
            levels: [],
            scope: '',
            level: '',
            levelToggle: 0,
            dashboard: undefined,
            dashboardOptions: [],
            showAreYouSure: false,
            makeTemplate: false,
        }
    }

    changeScope = ({ value: scope }) => {
        const { DynamicDashboardStore } = this.props
        const { dashboards } = DynamicDashboardStore
        const levels = new Set()
        dashboards.filter((d) => d.oId === scope).forEach((d) => {
            const level = R.pathOr(undefined, ['widgets', 'defaultDashSettings', 'level'], d)
            if (level) levels.add(level)
        })

        this.setState({
            levels: [...levels].map((l) => ({ label: l, value: l })),
            level: '',
            scope,
        })
    }

    changeLevel = ({ value: level }) => {
        const { DynamicDashboardStore } = this.props
        const { appStore, dashboards } = DynamicDashboardStore
        const { clientId } = appStore.userData
        const { scope } = this.state
        const dashboardOptions = dashboards.filter((d) => (
            d.clientId === clientId && d.oId === scope
        ))
        this.setState({ level, dashboardOptions })
    }

    setDefaults = (resetOnly) => {
        const { DynamicDashboardStore, toggleShowDefaultModal } = this.props
        const { setDefaults } = DynamicDashboardStore
        const {
            scope, level, dashboard, makeTemplate,
        } = this.state
        if (resetOnly) {
            setDefaults(undefined, scope, level, true)
            return
        }
        setDefaults(dashboard.dashboardId, scope, level, false, makeTemplate)
        toggleShowDefaultModal()
    }

    toggleAreyouSure = () => {
        this.setState((prevState) => ({ showAreYouSure: !prevState.showAreYouSure }))
    }

    changeDashboard = (dashboard) => this.setState({ dashboard })

    toggleMakeTemplate = () => (
        this.setState((prevState) => ({ makeTemplate: !prevState.makeTemplate }))
    )

    render() {
        const {
            showDefaultModal, toggleShowDefaultModal, DynamicDashboardStore,
        } = this.props
        const {
            scope,
            level,
            levels,
            levelToggle,
            dashboard,
            showAreYouSure,
            dashboardOptions,
            makeTemplate,
        } = this.state
        const { getChartScope, oId } = DynamicDashboardStore
        return (
            <Fragment>
                <Modal show={showDefaultModal} onClose={toggleShowDefaultModal} cssClass="dashboardCreationWizard">
                    <Panel style={{ overflow: 'visible' }}>
                        <Select
                            cssClass="formControl"
                            options={this.scopeOptions.filter((s) => s.value >= oId)}
                            onBlur={this.changeScope}
                            value={this.scopeOptions.find((s) => s.value === scope)}
                            label="Scope"
                            name="Scope"
                            blurOnClear
                        />
                        {!!scope
                   && (
                       <div>
                           <div style={{ display: 'flex', marginBottom: '30px', fontSize: '16px' }}>
                               <div
                                   style={{ marginRight: '20px', textDecoration: levelToggle === 0 ? 'underline #16CCC1' : 'none', cursor: 'pointer' }}
                                   onClick={() => this.setState({ levelToggle: 0, level: '' })}
                               >
                                   Existing Levels
                               </div>
                               <div
                                   style={{ textDecoration: levelToggle === 1 ? 'underline #16CCC1' : 'none', cursor: 'pointer' }}
                                   onClick={() => this.setState({ levelToggle: 1, level: '' })}
                               >
                                   Create New Level
                               </div>
                           </div>
                           {levelToggle === 0
                               ? (
                                   <Select
                                       cssClass="formControl"
                                       options={levels}
                                       onBlur={this.changeLevel}
                                       value={levels.find((l) => l.value === level)}
                                       label="Level"
                                       name="Level"
                                       blurOnClear
                                   />
                               )
                               : (
                                   <Input
                                       name="Level"
                                       defaultValue={level}
                                       onBlur={this.changeLevel}
                                       label="Enter A New Level Name"
                                   />
                               )}
                       </div>
                   )}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {level && scope ? (
                                <div style={{
                                    width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
                                }}
                                >
                                    <Button
                                        label="Reset All Defaults"
                                        cssClass="primary regular"
                                        style={{ width: '134px', margin: '20px 0' }}
                                        onClick={this.toggleAreyouSure}
                                    />
                                    <Select
                                        cssClass="formControl"
                                        options={dashboardOptions}
                                        onBlur={this.changeDashboard}
                                        value={dashboard}
                                        label="Dashboard"
                                        name="Dashboard"
                                        style={{ marginTop: '20px', width: '100%' }}
                                        blurOnClear
                                    />
                                </div>
                            ) : null}
                            {level && scope && dashboard ? (
                                <Fragment>
                                    {oId !== 3
                                    && (
                                        <Checkbox
                                            label={`Set dashboard as ${getChartScope(scope)} template`}
                                            value={makeTemplate}
                                            onBlur={this.toggleMakeTemplate}
                                            style={{ alignSelf: 'flex-start', marginTop: '15px' }}
                                        />
                                    )}
                                    <Button
                                        label="Set Default"
                                        cssClass="primary regular"
                                        style={{ width: '134px', margin: '20px 0' }}
                                        onClick={() => this.setDefaults(false)}
                                    />
                                </Fragment>

                            ) : null}
                        </div>
                    </Panel>
                </Modal>
                <Modal show={showAreYouSure} onClose={this.toggleAreyouSure}>
                    <h3>Are you sure you want to reset all defaults for this scope and level?</h3>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button
                            label="Cancel"
                            cssClass="tertiary regular"
                            style={{ width: '134px', margin: '20px 0' }}
                            onClick={this.toggleAreyouSure}
                        />
                        <Button
                            label="Confirm"
                            cssClass="primary regular"
                            style={{ width: '134px', margin: '20px 0' }}
                            onClick={() => {
                                this.toggleAreyouSure()
                                this.setDefaults(true)
                            }}
                        />
                    </div>
                </Modal>
            </Fragment>
        )
    }
}

export default DefaultDashboardSetter
